import { type Event, type User } from '@kalos/kalos-rpc';

export const getFileName = (arg: { serviceItemId: Event['id']; customerId: User['id'] }) => {
  return `${arg.serviceItemId}_pending_proposal_${arg.customerId || ''}`;
};
